import React from 'react'
import { useTranslation } from 'react-i18next'

import { CAMPAIGNS } from '../../fields'

import MultipleOptionsField from '../../../../../ReusableFormFields/MultipleOptionsField'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function CampaignsSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Campaign IDs')}</h3>
      <p>{t('Please enter the campaign ID or IDs that determine which ad items to display.')}</p>
      <MultipleOptionsField fieldLabel="campaign" listFieldName={CAMPAIGNS} formik={formik} />
    </section>
  )
}

export default CampaignsSection
